import { GlobalState } from "little-state-machine";

const initialState = () : GlobalState => ({

  username: undefined,
  userRole: undefined,
  menuItems: undefined,
  loggingOut: false,
  editRegionRequest: undefined,
  systemSettings: undefined,
  editVehicleRequest: undefined,
  raiseWorkOrderDetails: undefined,
  isMenuOpen: true
});

export { initialState };
